import { useCallback } from "react";

import type { GoogleDriveResponse } from "./types";
import useFetchContract from "./use-fetch-contract";

export default function useGoogleDrive() {
  const { isLoading, error, get } = useFetchContract();

  const getDrives = useCallback(async () => {
    const res = (await get("google/drives")) as any;
    return res.data;
  }, [get]);

  const getFiles = async (drive: string, folder: string) => {
    const searchParams = new URLSearchParams({
      drive,
      folder,
    }).toString();

    const res = (await get("google/files", {
      searchParams,
    })) as GoogleDriveResponse;
    return res.data;
  };

  return {
    isLoading,
    error,
    getDrives,
    getFiles,
  };
}
